import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { PreloadedImageTracker } from "@faire/retailer-visitor-shared/views/product/preload/PreloadedImageTracker";
import { buildProductImageGridSrcSet, IMAGE_GRID_MAX_IMAGES_VISIBLE } from "@faire/retailer-visitor-shared/views/product/ProductImages/utils";
import { prefetchLeanProduct } from "@faire/retailer-visitor-shared/views/product/utils/useLeanProductQuery";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
export function preloadNavigationToPDP(queryClient, product) {
    if (product.productToken) {
        prefetchLeanProduct(queryClient, product.productToken);
    }
    PreloadedImageTracker.get().clear();
    var Image = getWindowOrThrow().Image;
    var showVerticalImagery = product.showVerticalImagery || false;
    getUniqueImages(product).forEach(function(image) {
        var _buildProductImageGridSrcSet = buildProductImageGridSrcSet(image, showVerticalImagery), src = _buildProductImageGridSrcSet.src, srcSet = _buildProductImageGridSrcSet.srcSet;
        if (!src || !srcSet) {
            return;
        }
        var img = new Image();
        img.srcset = srcSet;
        img.src = src;
        PreloadedImageTracker.get().setInfo(src, {
            img: img,
            showVerticalImagery: showVerticalImagery
        });
    });
}
function getUniqueImages(product) {
    var images = product.images ? _to_consumable_array(product.images) : [];
    var bestImage = product.bestImage;
    if ((bestImage === null || bestImage === void 0 ? void 0 : bestImage.url) && images.every(function(image) {
        return image.url !== bestImage.url;
    })) {
        images.unshift(bestImage);
    }
    return images.slice(0, IMAGE_GRID_MAX_IMAGES_VISIBLE);
}
